import {AfterViewInit, Component, ElementRef, Inject, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Browser, Map, map, tileLayer, icon, marker, DomUtil} from 'leaflet';

export interface IMapControlResult {
  latitude: number;
  longitude: number;
  name: string;
}

@Component({
  selector: 'app-leaflet-dialog',
  templateUrl: './leaflet-dialog.component.html',
  styleUrl: './leaflet-dialog.component.scss'
})
export class LeafletDialogComponent implements AfterViewInit {
  @ViewChild('map') private mapContainer: ElementRef<HTMLElement>;
  center = {latitude: 48, longitude: 65};
  lat: number;
  lng: number;
  lefletMap: any;
  myIcon: any;
  mapMarkers: any[] = [];

  get hasCoordinates() {
    return this.data.latitude && this.data.longitude;
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IMapControlResult,
    public dialogRef: MatDialogRef<IMapControlResult>,
  ) {
    this.lat = data?.latitude || this.center.latitude;
    this.lng = data?.longitude || this.center.longitude;
  }

  ngAfterViewInit() {
    this.init();
  }

  init() {
    const initialState = {lat: this.lat, lng: this.lng, zoom: this.hasCoordinates ? 18 : 4.5};
    const lefletMap: Map = map(this.mapContainer.nativeElement, {attributionControl: false}).setView([initialState.lat, initialState.lng], initialState.zoom);
    this.lefletMap = lefletMap;
    const isRetina = Browser.retina;
    const baseUrl = "https://maps.geoapify.com/v1/tile/osm-bright/{z}/{x}/{y}.png?apiKey={apiKey}";
    const retinaUrl = "https://maps.geoapify.com/v1/tile/osm-bright/{z}/{x}/{y}@2x.png?apiKey={apiKey}";

    tileLayer(isRetina ? retinaUrl : baseUrl, {
      apiKey: '991dd5939a1d478e8300c13b896a476d',
      maxZoom: 20,
      crossOrigin: true
    } as any).addTo(lefletMap);

    this.myIcon = icon({
      iconUrl: './assets/marker-icon.png',
      shadowUrl: './assets/marker-shadow.png',
      iconSize: [25, 41],
      shadowSize: [41, 41],
      iconAnchor: [9, 40],
      shadowAnchor: [10, 39],
      popupAnchor: [4, -32]
    });

    if (this.hasCoordinates) {
      const myMarker = marker([this.lat, this.lng], {
        icon: this.myIcon
      } as any).addTo(lefletMap);
      myMarker.bindPopup(`<b>${this.data?.name || 'Объект'}</b>`, {autoPan: true, keepInView: true});
      this.mapMarkers.push(myMarker);
    }

    this.editable();
  }


  editable() {
    DomUtil.addClass(this.mapContainer.nativeElement, 'leaflet-crosshair');
    this.lefletMap.on('click', (event: any) => {
      for (let i = 0; i < this.mapMarkers.length; i++) {
        this.lefletMap.removeLayer(this.mapMarkers[i]);
      }
      this.lat = event.latlng.lat;
      this.lng = event.latlng.lng;
      const myMarker = marker([this.lat, this.lng], {
        icon: this.myIcon
      } as any);
      this.mapMarkers.push(myMarker);
      myMarker.addTo(this.lefletMap);
    });
  }

  save() {
    this.dialogRef.close({latitude: this.lat, longitude: this.lng});
  }

  close() {
    this.dialogRef.close();
  }
}
